export default {
  // Generic Mutation to allow store sync operation
  storeSync(state, arrow) {
    arrow(state);
  },
};
